import  {useState} from 'react';
import './App.css';
import Login from './Login';
import FlashMessage from './FlashMessage';
import Main from './Main';

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [signedUrl, setSignedUrl] = useState("");
  const [companySalt, setCompanySalt] = useState("");
  const [flashMessage, setFlashMessage] = useState("");
  const handleLoggedIn = (signedUrl: string, companySalt: string) => {
    setSignedUrl(signedUrl);
    setCompanySalt(companySalt);
    setLoggedIn(true);
  };
  const handleTimedOut = () => {
    setLoggedIn(false);
    setFlashMessage("タイムアウトしました");
  };
  const handleLoginFailed = () =>{
    setFlashMessage("ID・パスワードが間違ってます");
  };

  return (
    <div className="App">
      <h1>レセプト送信システム</h1>
      {!loggedIn && <FlashMessage message={flashMessage}/>}
      {!loggedIn && <Login handleLoggedIn={handleLoggedIn} handleLoginFailed={handleLoginFailed}/>}
      {loggedIn  && <Main handleTimedOut={handleTimedOut} signedUrl={signedUrl} companySalt={companySalt}/>}
      <div className="Footer">
        Copyright 2022 <a href="https://www.intage-realworld.co.jp/" target="_blank" rel="external noopener noreferrer">INTAGE Real World Inc.</a>
      </div>
    </div>
  );
}

export default App;
